import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid, Paper } from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ManualFloorRuleCard from './ManualFloorRuleCard';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';
import { MANUAL_FLOOR_KEYS } from '../../constants';
const { MANUAL_FLOOR_RULES_KEY, COUNTRY, AD_UNITS, PLATFORM, FLOOR } = MANUAL_FLOOR_KEYS;

const ManualFloorRulesConfig = () => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const commonStyleClasses = useCommonStyles();
	const manualFloorRulesArr = (bannerFpConfig && bannerFpConfig[MANUAL_FLOOR_RULES_KEY]) || [];

	const addNewManualFloorRuleObj = () => {
		const initialManualFloorRuleObj = {
			[AD_UNITS]: [],
			[COUNTRY]: [],
			[PLATFORM]: [],
			[FLOOR]: 0
		};
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		if (!clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY]) {
			clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY] = [];
		}
		clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY].push(initialManualFloorRuleObj);
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const deleteManualFloorRuleObj = (index) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const manualFloorRuleObj = clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY];

		const newManualFloorRuleArr = manualFloorRuleObj.filter((data, idx) => idx !== index);
		clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY] = newManualFloorRuleArr;

		updateBannerFpConfig(clonedBannerFpConfig);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Floor Engine Type Split"
				headingPath={['Dashboard', 'Banner Fp', 'Floor Pricing', 'Floor Engine Type Split']}
			/>
			<Grid container spacing={2} style={{ width: '94%', margin: '4rem auto 0 auto' }}>
				{manualFloorRulesArr && (
					<>
						{manualFloorRulesArr.map((manualFloorRuleObj, index) => {
							return (
								<ManualFloorRuleCard
									manualFloorRuleObj={manualFloorRuleObj}
									deleteManualFloorRuleObj={deleteManualFloorRuleObj}
									key={index}
									index={index}
								/>
							);
						})}
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<AddCircleOutlineOutlinedIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								onClick={addNewManualFloorRuleObj}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};

export default ManualFloorRulesConfig;
